package com.bikompanion.ui.settings

/**
 * The host's notification permission, which only the platform can read or change. [manage] calls
 * back once there is a new answer to read, on the platforms that get one without leaving the app.
 */
data class NotificationControls(
    val status: () -> NotificationStatus,
    val manage: (onDone: () -> Unit) -> Unit,
)
